<template>
  <div class="activity-list">
    <el-row
      :gutter="20"
      type="flex"
      justify="space-between"
      align="middle"
      style="border-bottom: 1px solid #ebeef5; padding-bottom: 6px"
      class="mb-2"
    >
      <el-col :span="12">
        <h3 class="text-muted">Recent Activities</h3>
      </el-col>
      <el-col :span="12" class="text-right">
        <el-button
          v-if="activities.length > 0"
          type="danger"
          size="mini"
          plain
          @click="removeAllActivity(activities)"
        >
          Clear All
        </el-button>
      </el-col>
    </el-row>

    <el-row v-if="activities.length === 0">
      <el-col :span="24">
        <div class="empty-message">
          <el-icon :size="30" class="el-icon-info"></el-icon>
          <p>No activities found</p>
          <p class="empty-subtext" style="color: #c0c4cc; font-size: 12px">
            Your activities will appear here once added
          </p>
        </div>
      </el-col>
    </el-row>

    <div v-else class="scroll-container">
      <div v-for="(row, index) in activities" :key="row.id || index" class="activity-item">
        <el-row type="flex" justify="space-between" align="middle">
          <el-col :span="16">
            <span>{{ index + 1 }}. {{ row.title }}</span>
            <el-tooltip v-if="row.error" :content="row.error">
              <i class="el-icon-warning" style="color: #ff4d4f; cursor: pointer"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="8" class="text-right activity-meta text-muted">
            <span class="small">{{ formatRelativeTime(row.date_created || row.timestamp) }}</span>
            <el-tooltip content="Delete" placement="top">
              <i
                class="el-icon-delete"
                @mouseover="hoverDelete = true"
                @mouseleave="hoverDelete = false"
                :style="{ cursor: 'pointer', color: hoverDelete ? '#ff4d4f' : 'inherit' }"
                @click="removeActivity(row)"
              ></i>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-progress
          v-if="row.activity_type === 1"
          :percentage="calculatePercentage(row)"
          :status="getProgressStatus(row)"
          show-text
          class="mt-1"
        ></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ActivitiesList',
  data() {
    return {
      hoverDelete: false,
    };
  },
  props: {
    activities: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    calculatePercentage(activity) {
      if (!activity.max_pos || activity.max_pos === 0) return 100;
      return Math.floor((activity.cur_pos / activity.max_pos) * 100);
    },
    getProgressStatus(activity) {
      if (activity.error) return 'exception';
      return this.calculatePercentage(activity) === 100 ? 'success' : 'active';
    },
    formatRelativeTime(timestamp) {
      if (!timestamp) return 'Just now';
      return moment(timestamp).fromNow();
    },
    removeActivity(activity) {
      this.$confirm('This will permanently delete the activity. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => this.$emit('deleteActivity', activity.id))
        .catch(() => {});
    },
    removeAllActivity(activities) {
      this.$confirm('This will permanently delete all activities. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          activities.forEach(a => this.$emit('deleteActivity', a.id));
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.activity-list {
  padding: 10px;
  min-width: 500px;
  width: 100%;
  color: #676a6c;
  white-space: nowrap;
  margin-bottom: 10px;
}
.activity-item {
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 12px;
}
.activity-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.activity-item:hover {
  color: #683090;
  cursor: pointer;
}
.empty-message {
  text-align: center;
  padding: 10px;
}
.el-icon-info {
  font-size: 20px;
  margin-bottom: 8px;
}
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overscroll-behavior: contain;
  border-bottom: 1px solid #ebeef5;
}
.scroll-container::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// ActivitiesList.vue?b6949426